import api from "Helpers/Api";
import { IPartners, PartnersRequestList } from "Services/Stores";
import { IPagination } from "Services/pagination";

export default async function storeList({
  search,
  selectedLetter,
  page,
  perPage,
  sort,
  order,
  categories,
  ...rest
}: PartnersRequestList) {
  const arr = categories?.split(",").map(c => c.trim()) ?? [];
  if (arr.length > 0 && arr.every(item => item.includes("vazio"))) {
    return {
      data: [],
      total: "0",
      sort: "",
      order: "asc",
    } as any;
  } else {
    categories = arr.filter(item => !item.includes("vazio")).join(",");
  }

  if (selectedLetter) {
    const { data } = await api.get<IPagination<IPartners>>(`partners/list`, {
      params: {
        search: selectedLetter,
        firstLetter: selectedLetter,
        perPage,
        page,
        sort,
        order,
        categories,
        ...rest,
      },
    });
    return data;
  }

  const { data } = await api.get<IPagination<IPartners>>(`partners/list`, {
    params: {
      search,
      perPage,
      page,
      sort,
      order,
      categories,
      ...rest,
    },
  });
  const now = new Date().getTime();
  data.data = data.data.sort((a, b) => {
    const aStart = a.highlight_start_at
      ? new Date(a.highlight_start_at).getTime()
      : null;
    const aEnd = a.highlight_expires_at
      ? new Date(a.highlight_expires_at).getTime()
      : null;
    const aIsActive =
      aStart !== null && aEnd !== null && now >= aStart && now <= aEnd;

    const bStart = b.highlight_start_at
      ? new Date(b.highlight_start_at).getTime()
      : null;
    const bEnd = b.highlight_expires_at
      ? new Date(b.highlight_expires_at).getTime()
      : null;
    const bIsActive =
      bStart !== null && bEnd !== null && now >= bStart && now <= bEnd;

    // Se A estiver ativo e B não → A vem antes
    if (aIsActive && !bIsActive) return -1;
    // Se B estiver ativo e A não → B vem antes
    if (!aIsActive && bIsActive) return 1;

    // Se os dois forem ativos ou inativos, ordena por highlight_start_at mais recente
    const timeA = aStart || 0;
    const timeB = bStart || 0;
    return timeB - timeA;
  });

  return data;
}
